import { H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { addImageParams, AddImageParamTypes } from '@/utils/urls';

type Props = {
    imageUrl: string;
    link: string;
    shouldUseSmallImageInset?: boolean;
    title: string;
};

export const CategoryModuleCard = ({ imageUrl, link, shouldUseSmallImageInset = false, title }: Props) => {
    const imageParams: AddImageParamTypes = {
        height: 160,
        url: imageUrl,
    };

    return (
        <div className="min-w-0 flex-1">
            <RouteLink
                className="relative flex w-full flex-col items-center gap-sm bg-background-primary no-underline mdMin:gap-md"
                to={link}
            >
                <div
                    className={cn(
                        'relative block w-full justify-center overflow-hidden bg-background-subdued',
                        shouldUseSmallImageInset ? 'p-xs' : 'p-xs mdMin:px-md mdMin:py-sm'
                    )}
                >
                    <img
                        alt={title}
                        className="w-full"
                        loading="lazy"
                        src={addImageParams(imageParams)}
                    />
                </div>
                <H3>{title}</H3>
            </RouteLink>
        </div>
    );
};
